import React from 'react';
import { t } from 'i18next';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import TimePicker from '../util/TimePicker';
import SettingsBlock from '../util/SettingsBlock';

interface NotificationsProps {
  financeMail: string;
  setFinanceMail: (v: string) => void;
  mailCronWeek: boolean;
  setMailCronWeek: (v: any) => void;
  dayWeek: string;
  setDayWeek: (v: string) => void;
  timeFrom: Date | null;
  handleTimeFromChange: (time: Date) => void;
  mailCronWeekApprove: boolean;
  setMailCronWeekApprove: (v: any) => void;
  dayWeekApprove: string;
  setDayWeekApprove: (v: string) => void;
  timeFromApprove: Date | null;
  handleTimeFromChangeApprove: (time: Date) => void;
  is24HourFormat: boolean;
  handleSaveMail: () => void;
  isLoading: boolean;
}

const Notifications: React.FC<NotificationsProps> = ({
  financeMail, setFinanceMail,
  mailCronWeek, setMailCronWeek,
  dayWeek, setDayWeek,
  timeFrom, handleTimeFromChange,
  mailCronWeekApprove, setMailCronWeekApprove,
  dayWeekApprove, setDayWeekApprove,
  timeFromApprove, handleTimeFromChangeApprove,
  is24HourFormat,
  handleSaveMail, isLoading,
}) => {

  const dayOptions = [
    { value: '1', label: t('Monday') || 'Monday' },
    { value: '2', label: t('Tuesday') || 'Tuesday' },
    { value: '3', label: t('Wednesday') || 'Wednesday' },
    { value: '4', label: t('Thursday') || 'Thursday' },
    { value: '5', label: t('Friday') || 'Friday' },
    { value: '6', label: t('Saturday') || 'Saturday' },
    { value: '7', label: t('Sunday') || 'Sunday' },
  ];

  return (
    <div>
      <SettingsBlock title="Finance Notifications">
        <div style={{ padding: '12px 16px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}>
            <label style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)', marginBottom: 4 }}>Finance Mail</label>
            <input
              className="timesheet-edit-input"
              style={{ maxWidth: 300, fontSize: 13, padding: '5px 8px', borderRadius: 5, background: 'var(--bg-input)', color: 'var(--text-color)', border: 'var(--border-input)' }}
              type="text"
              value={financeMail}
              onChange={e => setFinanceMail(e.target.value)}
            />
          </div>
        </div>
      </SettingsBlock>

      <SettingsBlock title="Timesheet Reminders">
        <div style={{ padding: '12px 16px' }}>
          <FormControlLabel
            control={<Checkbox onChange={() => setMailCronWeek((p: any) => !p)} checked={mailCronWeek} />}
            label="Regular Mailing"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'var(--text-color)' } }}
          />
          {mailCronWeek && (
            <div style={{ maxWidth: 300, marginTop: 8, marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <select
                  onChange={e => setDayWeek(e.target.value)}
                  value={dayWeek}
                  style={{ flex: 1, fontSize: 13, padding: '5px 8px', borderRadius: 5, background: 'var(--bg-input)', color: 'var(--text-color)', border: 'var(--border-input)' }}
                >
                  {dayOptions.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </select>
                <div style={{ width: 100 }}>
                  <TimePicker
                    mode="single"
                    variant="bare"
                    className="timesheets-input-all"
                    value={timeFrom}
                    onChange={(time: any) => handleTimeFromChange(time)}
                    step={60}
                    is24Hour={is24HourFormat}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </SettingsBlock>

      <SettingsBlock title="Approval Reminders">
        <div style={{ padding: '12px 16px' }}>
          <FormControlLabel
            control={<Checkbox onChange={() => setMailCronWeekApprove((p: any) => !p)} checked={mailCronWeekApprove} />}
            label="Approve Reports Reminder"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'var(--text-color)' } }}
          />
          {mailCronWeekApprove && (
            <div style={{ maxWidth: 300, marginTop: 8, marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <select
                  onChange={e => setDayWeekApprove(e.target.value)}
                  value={dayWeekApprove}
                  style={{ flex: 1, fontSize: 13, padding: '5px 8px', borderRadius: 5, background: 'var(--bg-input)', color: 'var(--text-color)', border: 'var(--border-input)' }}
                >
                  {dayOptions.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </select>
                <div style={{ width: 100 }}>
                  <TimePicker
                    mode="single"
                    variant="bare"
                    className="timesheets-input-all"
                    value={timeFromApprove}
                    onChange={(time: any) => handleTimeFromChangeApprove(time)}
                    step={60}
                    is24Hour={is24HourFormat}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </SettingsBlock>

      <div style={{ marginTop: 8 }}>
        <Button
          variant="outlined"
          color="success"
          onClick={handleSaveMail}
          disabled={isLoading}
          sx={{ fontSize: 13, whiteSpace: 'nowrap', minWidth: 160, height: 32 }}
        >
          {isLoading ? <CircularProgress size={18} color="inherit" /> : t('Save Change')}
        </Button>
      </div>
    </div>
  );
};

export default Notifications;
